import * as axios from 'axios';

export const CLEAR_CLASS_SESSIONS = '/classes/clear_class_sessions';
export const LOAD_CLASS_SESSIONS = '/classes/load_class_sessions';
export const SET_CLASS_SESSION_ENROLLMENT = '/classes/set_class_session_enrollment';

const moment = require('moment');

const retrieveSessionEnrollments = async (session, page, perPage, cumulatedResults) => {
  const resultPage = await axios.get(`/api/v1/my_class/session_enrollments.json?page=${page}&per_page=${perPage}&session_id=${session.id}&class=true&location=true&category=true&class_setting=true&session_enrollment_events=true&client=true&child=true&session_attendees=true&attendee=true&num_checked_in=true&not_canceled=true`)
  cumulatedResults.push(...resultPage.data.session_enrollments)
  if (resultPage.data.total > (page * perPage)) {
    await retrieveSessionEnrollments(session, page+1, perPage, cumulatedResults)
  }
  return cumulatedResults
}

export function getClasses(locationId, clientId) {
  return function(dispatch) {
    dispatch({ type: CLEAR_CLASS_SESSIONS });
    const startDate = moment().format('YYYY-MM-DD')
    const endDate = moment().add(1, 'day').format('YYYY-MM-DD')
    const availableClassSessionsMappedById = {}

    return axios
      .get(`/api/v1/my_class/sessions.json?start_date=${startDate}&end_date=${endDate}&child_label=true&notes=true&member_info=true&exclude_returnable_attributes=true&location_id=${locationId}&segments=true&class_name=true&total_capacity=true`)
      .then(async (result) => {
        const allResults = []
        const sessions = result.data.sessions
        for (let i = 0; i < sessions.length; i++) {
          availableClassSessionsMappedById[sessions[i].id] = sessions[i]
          const newResultsPage = await retrieveSessionEnrollments(sessions[i], 1, 100, [])
          allResults.push(...newResultsPage)
        }
        return allResults
      })
      .then((sessionEnrollments) => {
        const classSessionEnrollmentsForClient = []
        // statuses to ignore -> checked_in, canceled
        const filteredSessionEnrollments = sessionEnrollments.filter(({my_client_client_id, status}) => +my_client_client_id === clientId && !['checked_in', 'canceled'].includes(status))
        classSessionEnrollmentsForClient.push(...filteredSessionEnrollments)

        dispatch({ type: LOAD_CLASS_SESSIONS, data: {
          classSessionEnrollments: classSessionEnrollmentsForClient,
          classSessionsById: availableClassSessionsMappedById,
        }})

        if (classSessionEnrollmentsForClient.length > 0) {
          return Promise.resolve(true);
        } else {
          return Promise.resolve(false);
        }
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}

export function confirmClassSession(sessionEnrollmentId) {
  return function(dispatch) {
    return axios
      .post(`/api/v1/my_class/session_enrollments/${sessionEnrollmentId}/check_in.json`)
      .then((res) => {
        dispatch({ type: SET_CLASS_SESSION_ENROLLMENT, data: res.data.session_enrollment });
        return Promise.resolve(true);
      })
      .catch(error => {
        console.log(error);
        // eslint-disable-next-line
        Raven.captureException(error);
        return Promise.resolve(false);
      });
  };
}